import { Link } from "react-router-dom";
import { X, Zap } from "lucide-react";

const actionCopy = {
  join: { title: "Sign up to join this", body: "Guests can browse, but you'll need an account to join activities, chat with the group, and earn tokens." },
  create: { title: "Sign up to create activities", body: "Hosting on Grabb is free. You'll get 100 starter tokens and a unique referral code." },
  chat: { title: "Sign up to chat", body: "Group coordination happens in real-time chat. Free to sign up." },
  go_live: { title: "Sign up to go live", body: "Broadcast your availability and let people grab you for activities nearby." },
};

const FrictionModal = ({ open, onClose, action = "join" }) => {
  if (!open) return null;
  const { title, body } = actionCopy[action] || actionCopy.join;
  return (
    <div
      className="fixed inset-0 z-50 bg-black/50 flex items-end sm:items-center justify-center px-4"
      onClick={onClose}
      data-testid="friction-modal"
    >
      <div
        className="bg-white brutal-border rounded-2xl brutal-shadow-lg w-full max-w-sm p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between mb-4">
          <div className="w-12 h-12 bg-[#FFCC00] brutal-border rounded-xl flex items-center justify-center">
            <Zap className="w-6 h-6" strokeWidth={2.5} />
          </div>
          <button onClick={onClose} className="text-[#555555]" data-testid="friction-close">
            <X className="w-5 h-5" />
          </button>
        </div>
        <h3 className="font-heading font-black text-2xl mb-2">{title}</h3>
        <p className="text-[#555555] mb-6">{body}</p>
        <div className="space-y-2">
          <Link
            to="/register"
            onClick={onClose}
            className="block w-full text-center brutal-btn bg-[#FF6A2C] text-white py-3"
            data-testid="friction-signup"
          >
            Sign up — 100 free tokens
          </Link>
          <Link
            to="/login"
            onClick={onClose}
            className="block w-full text-center brutal-btn bg-white py-3"
            data-testid="friction-login"
          >
            I have an account
          </Link>
          <button
            onClick={onClose}
            className="block w-full text-center text-sm text-[#555555] py-2"
            data-testid="friction-keep-browsing"
          >
            Keep browsing
          </button>
        </div>
      </div>
    </div>
  );
};

export default FrictionModal;
